import classNames from 'classnames';
import { BorderlessStar } from 'components/Icons';
import React from 'react';
import FontAwesome from 'react-fontawesome';
import type { Merge } from 'types/utility';
import styles from './InputDecorator.module.scss';

interface OwnProps {
  style?: React.CSSProperties;
  className?: string;
  children: React.ReactElement;
  onClear?: (event: React.SyntheticEvent) => void;
  isClearable?: boolean;
  faIcon?: string;
  size?: string;
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
  inputType?: 'number';
  isLockedFeature?: boolean;
  inline?: boolean;
  hideClearButton?: boolean;
}

export type Props = Merge<React.HTMLProps<HTMLDivElement>, OwnProps>;

const InputDecorator = (props: Props) => {
  const {
    className,
    faIcon,
    hideClearButton,
    inline,
    inputType,
    isClearable,
    isLockedFeature,
    onClear,
    prefix,
    size = 'medium',
    suffix,
    ...rest
  } = props;
  const containerClass = classNames(styles.container, styles[size], className, {
    [styles.overlayRight]: isClearable || suffix,
    [styles.adjustForNumberDials]: inputType === 'number',
    [styles.overlayLeft]: faIcon || prefix,
    [styles.overlayLeftIsWide]:
      React.isValidElement(prefix) || (typeof prefix === 'string' && prefix.length > 2),
    [styles.inline]: inline,
  });

  return (
    <div className={containerClass} {...rest}>
      {isLockedFeature ? <BorderlessStar className={styles.lockedFeatureIcon} /> : false}
      {isClearable && !hideClearButton && (
        <div
          className={styles.clearable}
          onClick={props.onClear ? props.onClear : undefined}
          role="button"
        >
          <FontAwesome name="close" />
        </div>
      )}
      {(faIcon || prefix) && (
        <div className={styles.leftIcon}>
          {faIcon ? (
            <FontAwesome name={faIcon} />
          ) : typeof prefix === 'string' ? (
            <span>{prefix}</span>
          ) : (
            prefix
          )}
        </div>
      )}
      {props.children}
      {suffix && (
        <div className={styles.rightIcon}>
          {typeof suffix === 'string' ? <span>{suffix}</span> : suffix}
        </div>
      )}
    </div>
  );
};

InputDecorator.displayName = 'InputDecorator';

export default InputDecorator;
